// extracted by mini-css-extract-plugin
export default {"wbLoading":"kdz9myUY","spinner":"MhfhW6eL","wbLoadingSmall":"eM7uOYgS","wbLoadingLarge":"L3SKGn1b"};